import { CSSProperties, ReactNode } from 'react';

export interface ICol {
    tag?: string;
    className?: string;
    children?: ReactNode;

    xs: number | string;
    sm?: number | string;
    md?: number | string;
    lg?: number | string;
    xl?: number | string;

    xsTop?: ElementType<typeof INDENTS>;
    smTop?: ElementType<typeof INDENTS>;
    mdTop?: ElementType<typeof INDENTS>;
    lgTop?: ElementType<typeof INDENTS>;
    xlTop?: ElementType<typeof INDENTS>;

    xsBottom?: ElementType<typeof INDENTS>;
    smBottom?: ElementType<typeof INDENTS>;
    mdBottom?: ElementType<typeof INDENTS>;
    lgBottom?: ElementType<typeof INDENTS>;
    xlBottom?: ElementType<typeof INDENTS>;

    xsOrder?: ElementType<typeof ORDERS>;
    smOrder?: ElementType<typeof ORDERS>;
    mdOrder?: ElementType<typeof ORDERS>;
    lgOrder?: ElementType<typeof ORDERS>;
    xlOrder?: ElementType<typeof ORDERS>;

    xsAlign?: ElementType<typeof ALIGNS>;
    smAlign?: ElementType<typeof ALIGNS>;
    mdAlign?: ElementType<typeof ALIGNS>;
    lgAlign?: ElementType<typeof ALIGNS>;
    xlAlign?: ElementType<typeof ALIGNS>;

    style?: CSSProperties;
}
// eslint-disable-next-line @typescript-eslint/naming-convention,@typescript-eslint/no-shadow
type ElementType<T extends ReadonlyArray<unknown>> = T extends ReadonlyArray<infer ElementType> ? ElementType : never;

const ORDERS = ['first', 'last', 'unset'] as const;
const ALIGNS = ['top', 'middle', 'bottom', 'unset'] as const;
const INDENTS = [
    0,
    5,
    10,
    15,
    20,
    30,
    40,
    50,
    60,
    80,
    100,
    '0',
    '5',
    '10',
    '15',
    '20',
    '30',
    '40',
    '50',
    '60',
    '80',
    '100',
] as const;

export const propTypes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xsTop',
    'smTop',
    'mdTop',
    'lgTop',
    'xlTop',
    'xsBottom',
    'smBottom',
    'mdBottom',
    'lgBottom',
    'xlBottom',
    'xsAlign',
    'smAlign',
    'mdAlign',
    'lgAlign',
    'xlAlign',
    'xsOrder',
    'smOrder',
    'mdOrder',
    'lgOrder',
    'xlOrder',
    'style',
];
